import { render } from "./Header.vue?vue&type=template&id=9791632c&scoped=true"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import "./Header.vue?vue&type=style&index=0&id=9791632c&scoped=true&lang=css"

import exportComponent from "C:\\wamp64\\www\\lpdadsm-master\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9791632c"]])

export default __exports__